/* eslint-disable react/prop-types */
import React, { useState } from "react";
import DataTable from "components/organisms/DataTable/DataTable";
import { FormattedMessage, useIntl } from "react-intl";
import { getCompanyApprovalLevels } from "api";
import Button from "components/atoms/Button/Button";
import useTableRequest from "hooks/useTableRequest";
import GlobalTableSearch from "components/organisms/DataTable/components/GlobalTableSearch";
import usePermissions from "hooks/usePermissions";
import NewApprovalDialog from "./NewApprovalDialog";

function CompanyLevel() {
  const intl = useIntl();
  const [levelId, setLevelId] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const { permissions } = usePermissions();
  const adminSettings = JSON.parse(permissions || "{}")?.permissions?.admin_settings;
  const viewOnly = Boolean(!adminSettings?.edit_approval_levels);

  const columns = [
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableLevelHeader", defaultMessage: "Level" }),
      accessor: "name",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1 font-weight-bold">{value}</p>,
    },
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableOrderHeader", defaultMessage: "Order" }),
      accessor: "order",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1">{value}</p>,
    },
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableAmountHeader", defaultMessage: "Amount" }),
      accessor: "amount",
      sortable: true,
      Cell: ({ value }) => <p className="pl-9 pt-8 pb-8 mb-0 mr-1">{value}</p>,
    },
    {
      Header: intl.formatMessage({ id: "settings.approval-level.tableMembersHeader", defaultMessage: "Members" }),
      accessor: "members",
      sortable: true,
      Cell: ({ value }) => {
        const members = value.map((member) => member).join(", ");
        return <p className="pl-9 pt-8 pb-8 mb-0 mr-1">{members}</p>;
      },
    },
  ];

  const { instance, fetching, totalData, refetch } = useTableRequest(getCompanyApprovalLevels, columns, {
    filters: (globalFilter) => ({
      ...(globalFilter.query?.length && { query: globalFilter.query }),
    }),
    deps: [location],
  });

  const handleCloseDialog = () => {
    setLevelId(null);
    setShowDialog(false);
  };

  return (
    <div>
      <NewApprovalDialog
        totalOrders={instance?.data?.length ? instance?.data?.length : 1}
        refetch={refetch}
        id={levelId}
        close={handleCloseDialog}
        isOpen={showDialog}
        viewOnly={viewOnly}
      />
      <DataTable
        tableInstance={instance}
        totalData={totalData}
        isLoading={fetching}
        draggable={false}
        onRowClick={(row) => {
          setLevelId(row.original.id);
          setShowDialog(true);
        }}
        headerLeft={
          <div className="d-md-flex justify-content-between align-items-center flex-md-row flex-column w-100">
            <div className="font-weight-bold d-flex " style={{ fontSize: "24px", marginBottom: "16px", marginTop: "8px" }}>
              <FormattedMessage id="settings.approval-level.companyLevel" defaultMessage="Company level" />
              <div className="w-30-px ml-3 mt-1">
                <GlobalTableSearch
                  currentFilters={instance.state.globalFilter}
                  setFilters={instance.setGlobalFilter}
                  filterKey="query"
                  eventContext="Company level"
                />
              </div>
            </div>

            {!viewOnly && (
              <div className="d-flex align-items-center">
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setLevelId(null);
                    setShowDialog(true);
                  }}
                >
                  <FormattedMessage
                    id="settings.approval-level.newCompanyApprovalLevel"
                    defaultMessage="New company approval level"
                  />
                </Button>
              </div>
            )}
          </div>
        }
        headerRight={null}
      />
    </div>
  );
}

export default CompanyLevel;
